import { render, staticRenderFns } from "./ModalCompanyProduct.vue?vue&type=template&id=3d87fd07"
import script from "./ModalCompanyProduct.vue?vue&type=script&lang=js"
export * from "./ModalCompanyProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports